// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__2Ceif","pagination":"style_pagination__JK1mM","createButton":"style_createButton__2V3XO","wrapList":"style_wrapList__2TZgQ"};